import { setLocale } from "yup";
import { DICTIONARY_SCHEMA, i18n } from "@/plugins/i18n";
import type { Composer } from "vue-i18n";

export function initValidation() {
  const t = i18n.global.t as Composer["t"];

  setLocale({
    mixed: {
      required: t(DICTIONARY_SCHEMA.VALIDATIONS.REQUIRED),
    },
    string: {
      email: t(DICTIONARY_SCHEMA.VALIDATIONS.EMAIL),
    },
  });
}
